export default __webpack_public_path__ + "static/media/frog_R2_C5.17efea9f.png";